import { useState } from "react";
import { UserRolesModel, createUserRolesInfo } from "../../accounts/models/UserRolesInfo";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { Authentication } from "../../common/views/Authentication";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { ShortWebsiteModel } from "../../websites/models/WebsiteModel";
import { PopularSearchModel } from "../../websites/models/PopularSearchModel";
import { PopularSearchService } from "../../websites/services/PopularSearchService";
import { WebsiteService } from "../../websites/services/WebsiteService";
import { BannerInfo } from "../models/BannerInfo";
import { ContactInfo } from "../models/ContactInfo";
import HomeService from "../services/HomeService";

export function useHomeVM() {
    const homeService = new HomeService();
    const websiteService = new WebsiteService();
    const popularSearchService = new PopularSearchService();

    const [userRoles, setUserRoles] = useState<UserRolesModel>(createUserRolesInfo());
    const [contacts, setContacts] = useState<ContactInfo[]>([]);
    const [banners, setBanners] = useState<BannerInfo[]>([]);
    const [keyServices, setKeyServices] = useState<string[]>([]);

    //const [websites, setWebsites] = useState<ShortWebsiteModel[]>([]);
    //const [showAllWebsites, setShowAllWebsites] = useState(false);
    //const [websiteListHash, setWebsiteListHash] = useState<number>(0);

    //const [popularSearches, setPopularSearches] = useState<PopularSearchModel[]>([]);
    //const [searchListHash, setSearchListHash] = useState<number>(0);
    //const [showAllPopularSearches, setShowAllPopularSearches] = useState(false);

    //const [selectedSearch, setSelectedSearch] = useState<PopularSearchModel | undefined>(undefined);
    //const [showSearchDetail, setShowSearchDetail] = useState(false);

    const onLoad = () => {
        console.log("Home VM onloaded");
        setKeyServices(getKeyServices());

        setUserRoles(Authentication.getUserRoles());
        getContacts();
        getBanners();
        //getWebsites();
        //getPopularSearches();
    };

    const getKeyServices = () => {
        return [
            "Free Shopping Service",
            "Free Consolidation",
            "Ship By Air",
            "Delivery to Home"
        ];
    }

    //const getWebsites = () => {
    //    setWebsites([]);
    //    setWebsiteListHash(Utils.getRandomKey());

    //    const onResult = (result: IDataResult) => {
    //        if (result.status === ResponseStatus.success) {
    //            setWebsites(result.data);
    //            setWebsiteListHash(Utils.getRandomKey());
    //        }
    //    }

    //    DataUtils.onRequest(websiteService.getGetTopList(20), onResult);
    //}

    //const getPopularSearches = () => {
    //    setPopularSearches([]);
    //    setSearchListHash(Utils.getRandomKey());

    //    const onResult = (result: IDataResult) => {
    //        if (result.status === ResponseStatus.success) {
    //            setPopularSearches(result.data);
    //            setSearchListHash(Utils.getRandomKey());
    //        }
    //    }

    //    DataUtils.onRequest(popularSearchService.getOpenList(20), onResult);
    //}

    const getContacts = () => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setContacts(result.data);
            }
        }

        DataUtils.onRequest(homeService.getContacts(), onResult);
    }

    const getBanners = () => {
        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setBanners(result.data);
            }
        }

        const request = homeService.getBanners();
        DataUtils.onRequest(request, onResult);
    }

    return {
        onLoad,
        userRoles,
        setUserRoles,
        banners,
        contacts,
        keyServices,
        //websites, websiteListHash,
        //popularSearches, searchListHash,
        //selectedSearch, setSelectedSearch,
        //showSearchDetail, setShowSearchDetail,
        //showAllWebsites, setShowAllWebsites,
        //showAllPopularSearches, setShowAllPopularSearches
    }
}